var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight, } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import Dropdown from "@mui/joy/Dropdown";
import Menu from "@mui/joy/Menu";
import MenuButton from "@mui/joy/MenuButton";
import MenuItem from "@mui/joy/MenuItem";
export default function Placeholder(_a) {
    var _b;
    var menuItem = _a.menuItem;
    var t = useTranslation(["common"]).t;
    var _c = useState(null), openedMenu = _c[0], setOpenedMenu = _c[1];
    // show or not children's menu
    var toggleMenu = function (item) {
        if (openedMenu === item) {
            setOpenedMenu(null);
        }
        else {
            setOpenedMenu(item);
        }
    };
    return (_jsx("div", __assign({ id: "mega-menu", className: "items-center justify-between hidden w-full md:flex md:w-auto md:order-1" }, { children: (_b = Object.keys(menuItem)) === null || _b === void 0 ? void 0 : _b.map(function (item, key) { return (_jsx(Dropdown, { children: _jsxs("div", __assign({ className: "list-none menu-contain mx-2 ".concat(openedMenu === item ? "open" : "") }, { children: [_jsxs("p", __assign({ className: "menu-contain__label flex uppercase cursor-pointer text-justify p-1 relative ".concat(openedMenu === item ? "bg-[#eef1f7]" : "") }, { children: [_jsx("span", __assign({ className: "pr-6" }, { children: t("app.".concat(item), {
                                    ns: "common",
                                }) })), _jsx(MenuButton, __assign({ sx: { border: "none" } }, { children: _jsx(FontAwesomeIcon, { icon: openedMenu === item ? faChevronDown : faChevronRight, onClick: function () { return toggleMenu(item); }, className: "absolute top-[5px]" }) }))] })), _jsx(Menu, __assign({ placement: "bottom-end", className: "max-h-[250px] min-w-[200px]" }, { children: Object.values(menuItem[item]).map(function (i) {
                            return Object.values(i).map(function (m, key) { return (_jsx(MenuItem, __assign({ className: "hover:bg-[#eef1f7] px-2 py-1" }, { children: _jsx("a", __assign({ href: "".concat(process.env.PUBLIC_URL, "/modules/").concat(m.modules.module), title: m.modules.module }, { children: _jsx("span", { children: t(m.modules.label) }) })) }), key)); });
                        }) }))] }), key) })); }) })));
}
